import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, Trophy, Sparkles, Users } from 'lucide-react';
export function DoSomeMartialArtsClasses() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-919">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-920">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-921">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-922">
            Classes for Kids, Adults & Families
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-923">
            Whoever you are — whatever you're bringing to the mat — Storm has a
            starting class that fits.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-924">
          {[{
          icon: Sprout,
          age: 'Ages 3–5',
          title: 'Mini Troopers',
          desc: 'Preschool-friendly classes that build listening, balance, and confidence.',
          href: '/mini-troopers'
        }, {
          icon: Trophy,
          age: 'Ages 6+',
          title: 'Kids Taekwondo',
          desc: 'Real Taekwondo training in a positive, structured environment.',
          href: '/karate-kids-classes.html'
        }, {
          icon: Sparkles,
          age: 'Adults',
          title: 'Adult Classes',
          desc: 'Beginner-friendly adult Taekwondo for fitness, confidence, and skill.',
          href: '/karate-adult-classes'
        }, {
          icon: Users,
          age: 'All Ages',
          title: 'Family Classes',
          desc: 'Parents and kids train side by side on the same mat.',
          href: '/FamilyKarateClasses.html'
        }].map((p, i) => <Link key={i} to={p.href} className="group bg-off-white border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3 hover:border-storm-red transition-colors" data-id="element-925">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red group-hover:bg-storm-red group-hover:text-white transition-colors" data-id="element-926">
                <p.icon className="w-6 h-6" data-id="element-927" />
              </div>
              <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-928">
                {p.age}
              </p>
              <h3 className="text-lg text-ink leading-tight" data-id="element-929">{p.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed flex-grow" data-id="element-930">
                {p.desc}
              </p>
              <span className="text-storm-red font-bold text-sm group-hover:underline" data-id="element-931">
                Learn more →
              </span>
            </Link>)}
        </div>

        <div className="text-center mt-10" data-id="element-932">
          <Link to="/Programs.html" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-933">
            See All Programs →
          </Link>
        </div>
      </div>
    </section>;
}